import React from "react";

export const MessengerSidebar = () => {
  return (
    <div className="MessengerSidebar">
      Messenger Sidebar
    </div>
  )
}
